import { useEffect, useState } from "react";

export type ThemeChoice = "system" | "light" | "dark";
const KEY = "pw-theme";

function read(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function useTheme() {
  const [theme, setTheme] = useState<ThemeChoice>(read);
  useEffect(() => {
    const el = document.documentElement;
    if (theme === "system") delete el.dataset.theme;
    else el.dataset.theme = theme;
    try {
      if (theme === "system") localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, theme);
    } catch {
      /* geen opslag beschikbaar */
    }
  }, [theme]);
  return [theme, setTheme] as const;
}

export const THEME_LABEL: Record<ThemeChoice, string> = { system: "Systeem", light: "Licht", dark: "Donker" };
export const nextTheme = (t: ThemeChoice): ThemeChoice =>
  t === "system" ? "light" : t === "light" ? "dark" : "system";
